import React from "react";
import {Row, Col} from "antd";
import {FooterSection, FooterSectionLink} from "../../../components/DesignSystem/FooterSection/FooterSection";
import {useHistory} from "react-router-dom";


export const PageFooterLink = () => {

    let history = useHistory();

    return <Row gutter={16}>
        <Col sm={8}>
            Apimoon is an ai data platform
        </Col>
        <Col sm={4}>
            <FooterSection>ACCOUNT</FooterSection>
            <FooterSectionLink href={"/login"}>Sign In</FooterSectionLink>
            <FooterSectionLink href={"/sign-up"}>Sign Up</FooterSectionLink>
            <FooterSectionLink href={"/reset-password-request"}>Reset password</FooterSectionLink>
            <FooterSectionLink onClick={() => history.push("/contact-sales")}>Request demo</FooterSectionLink>
        </Col>
        <Col sm={4}>
            <FooterSection>DATA VIEWERS</FooterSection>
            <FooterSectionLink href={"/csv/view"}>CSV Viewer</FooterSectionLink>
            <FooterSectionLink href={"/parquet/view"}>Parquet Viewer</FooterSectionLink>
            <FooterSectionLink href={"/excel/view"}>Excel Viewer</FooterSectionLink>
            <FooterSectionLink href={"/tsv/view"}>TSV Viewer</FooterSectionLink>
            <FooterSectionLink href={"/json/view"}>JSON Viewer</FooterSectionLink>
        </Col>
        <Col sm={4}>
            <FooterSection>DATA TOOLS</FooterSection>
            <FooterSectionLink href={"/csv/view"}>CSV Converter</FooterSectionLink>
            <FooterSectionLink href={"/parquet/view"}>Parquet Converter</FooterSectionLink>
            <FooterSectionLink href={"/excel/view"}>Excel Converter</FooterSectionLink>
            <FooterSectionLink href={"/tsv/view"}>TSV Converter</FooterSectionLink>
            <FooterSectionLink href={"/json/view"}>JSON Converter</FooterSectionLink>
        </Col>
        <Col sm={4}>
            <FooterSection>SAMPLE DATA</FooterSection>
            <FooterSectionLink href={"/csv/samples"}>CSV Samples</FooterSectionLink>
            <FooterSectionLink href={"/parquet/samples"}>Parquet Samples</FooterSectionLink>
            {/*<FooterSectionLink href={"/csv/samples"}>CSV Samples</FooterSectionLink>*/}
            {/*<FooterSectionLink href={"/csv/samples"}>CSV Samples</FooterSectionLink>*/}
        </Col>
    </Row>
}